import {QuizPopup, QuizPopupParams} from "./quiz-popup";

export interface QuizPopupBtnParams {
    codeAttribute: string;
}

export class QuizPopupBtn {
    protected popup: QuizPopup;

    constructor(
        protected button: HTMLElement,
        protected params: QuizPopupBtnParams
    ) {
        const code = this.button.getAttribute(this.params.codeAttribute);

        console.log('[QUIZ_CODE]', this.button, code);

        if (!code) {
            return;
        }

        this.popup = new QuizPopup({code});
        this.button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();

            this.popup.show();
        });
    }
}

export function useQuizPopupBtn(selectors: string, params: QuizPopupBtnParams): void {
    Array.from(document.querySelectorAll<HTMLElement>(selectors)).forEach(el => {
        new QuizPopupBtn(el, params);
    })
}
